import gql from 'graphql-tag';

export const QUERY_PAYMENT_PLANS = gql`
  query queryPaymentPlans(
    $currency: String
    $pageNumber: PositiveInteger
    $pageSize: PositiveInteger
    $category: PaymentPlanCategory
    $landlordId: ID!
  ) {
    cmsPaymentPlans(
      currency: $currency
      pageSize: $pageSize
      pageNumber: $pageNumber
      category: $category
      landlordId: $landlordId
    ) {
      edges {
        node {
          hasIntegratedProperty
          paymentOnline
          category
          active
          id
          name
          currency
          description
          deposits {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
            createdAt
          }
          fees {
            amount
            currency
            description
            id
            name
            paymentType
            payThroughStcom
            createdAt
          }
          instalments {
            createdAt
            fromTenancy
            id
            payMonthly
            payQuarterly
            payWeekly
            payRemainderAtOnce
            fullPayment
            name
            paymentPlanId
            requireGuarantor
            tenancyUnit
            toTenancy
            payNowAmount
            updatedAt
            country {
              name
            }
          }
          properties {
            id
            name
            slug
            status
          }
          startDate
          endDate
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }
`;

export const updatePropertyDueHours = variables => ({
  operationName: 'CMS_UpdatePropertyDueHours',
  variables: {
    input: variables,
  },
  query: `mutation CMS_UpdatePropertyDueHours($input:UpdatePropertyDueHoursInput!) {
    cmsUpdatePropertyDueHours(input:$input){
      property {
          id
          slug
          drafts(
            sortBy: UPDATED_AT,
            pageNumber: 1,
            pageSize: 9999,
            statuses: [PENDING, REJECTED, EXPIRED],
          ) {
            edges {
              node {
                id
                status
                updatedAt
                changes
                category
                createdUser {
                  firstName
                  lastName
                  email
                }
                comments {
                  comment
                  id
                  section
                }
                image {
                  id
                  discriminator
                  category
                  size
                  extension
                  contentType
                  hero
                  path
                  position
                  source
                  filename
                  imageHash
                  status
                  unitTypeId
                }
                video {
                  id
                  path
                  transcodedStatus
                  links {
                    hls
                    hqMp4
                    lqMp4
                    thumbnail
                  }
                  locales
                  category
                  position
                  size
                  unitTypeId
                  videoHash
                  fileName
                  extension
                  transcodeJobId
                  transcodeJobStatus
                  status
                }
                propertyLink {
                  area
                  displayRegion
                  id
                  link
                  type
                  propertyId
                  status
                }
                unitTypeLink {
                  displayRegion
                  id
                  link
                  type
                  status
                  unitTypeId
                }
              }
            }
          }
        }
    }
  }
    `,
});
export const UPDATE_PROPERTY_PAYMENT_PLAN = gql`
  mutation updatePropertyPaymentPlan($input: UpdatePropertyPaymentPlanInput!) {
    cmsUpdatePropertyPaymentPlan(input: $input) {
      success
    }
  }
`;
